export default __webpack_public_path__ + "static/media/ba13.59e7c47c.jpg";